module.exports = __webpack_public_path__ + "static/media/w (10).f7b850cc.jpg";